import { computed } from "vue";

import { useMyStudentsAlgoliaIndex } from "./useMyStudentsAlgoliaIndex";

export const useRegisteredFacets = () => {
  const { hasGroupedOrders } = useMyStudentsAlgoliaIndex();

  const orderField = computed(() => {
    return hasGroupedOrders.value ? "orders" : "order";
  });

  const altOrderField = computed(() => {
    return hasGroupedOrders.value ? "order" : "orders";
  });

  const currentFacets = computed(() => {
    return [
      {
        attribute: `${orderField.value}.session.locations.country`,
        altAttribute: `${altOrderField.value}.session.locations.country`,
        paramName: "country",
        title: "Country",
        component: "CheckboxFilter",
        searchable: true,
      },
      {
        attribute: `${orderField.value}.session.locations.city`,
        altAttribute: `${altOrderField.value}.session.locations.city`,
        paramName: "city",
        title: "City",
        component: "CheckboxFilter",
        searchable: true,
      },
      {
        attribute: `${orderField.value}.session.name`,
        altAttribute: `${altOrderField.value}.session.name`,
        paramName: "session",
        title: "Session",
        component: "CheckboxFilter",
        searchable: true,
      },
      {
        attribute: `${orderField.value}.session.session_types`,
        altAttribute: `${altOrderField.value}.session.session_types`,
        paramName: "sessionType",
        title: "Session Type",
        component: "CheckboxFilter",
      },
      {
        attribute: `${orderField.value}.session.terms`,
        altAttribute: `${altOrderField.value}.session.terms`,
        paramName: "term",
        title: "Term",
        component: "CheckboxFilter",
      },
      {
        attribute: "student.areas_of_study.study_area",
        altAttribute: "student.areas_of_study.study_area",
        paramName: "study_area",
        title: "Area of Study",
        component: "CheckboxFilter",
        searchable: true,
      },
      {
        attribute: "student.graduating_year",
        altAttribute: "student.graduating_year",
        paramName: "graduating_year",
        title: "Graduating Year",
        component: "CheckboxFilter",
      },
      {
        attribute: `${orderField.value}.session.academic_year`,
        altAttribute: `${altOrderField.value}.session.academic_year`,
        paramName: "academic_year",
        title: "Academic Year",
        component: "CheckboxFilter",
      },
      {
        attribute: "student.status",
        altAttribute: "student.status",
        paramName: "status",
        title: "Status",
        component: "CheckboxFilter",
      },
      {
        attribute: `${orderField.value}.session.channel`,
        altAttribute: `${altOrderField.value}.session.channel`,
        paramName: "channel",
        title: "Channel",
        component: "CheckboxFilter",
      },
      {
        attribute: `${orderField.value}.session.deadline`,
        altAttribute: `${altOrderField.value}.session.deadline`,
        paramName: "deadline",
        title: "Application Deadline Proximity",
        component: "CheckboxFilter",
      },
      {
        attribute: `${orderField.value}.core.host_accepted_status`,
        altAttribute: `${altOrderField.value}.core.host_accepted_status`,
        paramName: "acceptance_status",
        title: "Acceptance Status",
        component: "CheckboxFilter",
      },
    ];
  });

  return { currentFacets };
};
